// extracted by mini-css-extract-plugin
export default {"root":"root__HT+ix","textContainer":"textContainer__sjOmM","link":"link__-RuLh","legalBannerLinks":"legalBannerLinks__KPoDI","hide":"hide__xr8S7"};